import { Box, Divider, Typography } from '@mui/material'
import dayjs from 'dayjs'
import React from 'react'
import { Link } from 'react-router-dom'
import palette from '../../theme/palette'
import { t } from 'i18next'
import { routes } from '../../pages/routes'
import { useLocales } from '../../hooks/useLocales'
import i18n from '../../locales'

function LegalFooter() {

  const currentLang = i18n.language

  const getCguLink = () => {
    if (currentLang === 'fr') {
      return 'https://equimetre-assets-next.s3.eu-west-3.amazonaws.com/build/legal/202108_ARIONEO_CGV_FR.pdf?38.1.0'
    }
    return 'https://equimetre-assets-next.s3.eu-west-3.amazonaws.com/build/legal/202108_ARIONEO_CGV_EN.pdf?38.1.0'
  }


  return (
    <Box display={'flex'} alignItems={'center'} gap={0.5} position={'absolute'} bottom={0} right={0} sx={{ backgroundColor: 'background.paper', borderTopLeftRadius: 5 }} p={1}>
      <Typography sx={{ textDecoration: 'none', '&:hover': { color: palette.light.primary.main } }} component={Link} target='_blank' to={'https://arioneo.com/'} variant='caption' fontSize={10}>© Arioneo {dayjs().year()}</Typography>
      <Divider flexItem orientation='vertical' />
      <Typography sx={{ textDecoration: 'none', '&:hover': { color: palette.light.primary.main } }} component={Link} target='_blank' to={routes.PUBLIC_ROUTES.legalNotice} variant='caption' fontSize={10}>{t('title')}</Typography>
      <Divider flexItem orientation='vertical' />
      <Typography sx={{ textDecoration: 'none', '&:hover': { color: palette.light.primary.main } }} component={Link} target='_blank' to={getCguLink()} variant='caption' fontSize={10}>{t('cgu')}</Typography>
      <Divider flexItem orientation='vertical' />
      <Typography sx={{ textDecoration: 'none', '&:hover': { color: palette.light.primary.main } }} component={Link} target='_blank' to={routes.PUBLIC_ROUTES.dataProtection} variant='caption' fontSize={10}>{t('dataProtection:link')}</Typography>

    </Box>
  )
}

export default LegalFooter